import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Tab from "react-bootstrap/Tab";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import "swiper/css";
import "swiper/css/navigation";

import Nav from "react-bootstrap/Nav";
import Anchor from "../elements/Anchor";

import arrow from "../../../static/images/icons/arrow-steps-title.svg";
import "../../styles/components/slices/steps.scss";

const Steps = ({ slice }) => {
  if (!slice) return null;
  const steps = slice.items;

  return (
    <Container fluid className="section steps">
      <Container className=" max-container">
        {/* desktop */}
        <Row className="justify-content-center d-none d-lg-flex">
          <Col md={5} className="align-self-center">
            <Row>
              <div className="title-65 color-main mb-4">
                <PrismicRichText field={slice.primary.title.richText} />
              </div>
              <div className="mb-4">
                <PrismicRichText field={slice.primary.description.richText} />
              </div>
              {slice.primary.button_label && (
                <div className="book-now-outline me-auto ms-2 d-none d-lg-block mona">
                  <Anchor
                    href={slice.primary.button_url.url}
                    className="book-now-btn text-center"
                    target={slice.primary.button_url.target}
                  >
                    {slice.primary.button_label}
                  </Anchor>
                </div>
              )}
            </Row>
          </Col>
          <Col md={7}>
            <Tab.Container id="steps" defaultActiveKey={steps[0].step_title}>
              <Row>
                <Col sm={6}>
                  <Nav variant="pills" className="flex-column">
                    {steps.map((step, index) => (
                      <Nav.Item
                        className="text-left steps-box mb-2"
                        key={index}
                      >
                        <Nav.Link
                          eventKey={step.step_title}
                          className="d-flex align-items-center"
                        >
                          <div className="step-n-box">
                            <div className="step-number text-center">
                              {index + 1}
                            </div>
                          </div>
                          <div className="step-title mx-3">
                            {step.step_title}
                          </div>
                          <div className="arrow-icon ms-auto">
                            <img src={arrow} alt="arrow" />
                          </div>
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>
                <Col sm={6}>
                  <Tab.Content className="h-100 d-flex">
                    {steps.map((step, index) => (
                      <Tab.Pane
                        eventKey={step.step_title}
                        className="align-self-center"
                        key={index}
                      >
                        <div className="mb-3 content-border">
                          <GatsbyImage
                            image={step.step_content_image.gatsbyImageData}
                            alt={step.step_content_image.alt || "steps image"}
                            className=""
                          />
                        </div>
                        <PrismicRichText field={step.step_content.richText} />
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>

        {/* mobile slider */}
        <Row className="justify-content-center d-flex d-lg-none">
          <Col lg={4} className="me-md-4">
            <Row>
              <div className="title-65 color-main mb-3">
                <PrismicRichText field={slice.primary.title.richText} />
              </div>
              <div className="mb-md-5">
                <PrismicRichText field={slice.primary.description.richText} />
              </div>
              {slice.primary.button_label && (
                <div className="book-now-outline me-auto ms-2 d-none d-lg-block mona">
                  <Anchor
                    href={slice.primary.button_url.url}
                    className="book-now-btn text-center"
                    target={slice.primary.button_url.target}
                  >
                    {slice.primary.button_label}
                  </Anchor>
                </div>
              )}
            </Row>
          </Col>
        </Row>

        <Row className="d-flex d-lg-none">
          <Swiper
            navigation
            slidesPerView={1}
            modules={[Navigation]}
            className="swiper-steps-mobile mt-2"
          >
            {slice.items?.map((box, index) => (
              <SwiperSlide key={index}>
                <div className="row w-100 justify-content-center">
                  <Col className="col-10">
                    <div
                      className="text-left steps-box my-4"
                      key={box.step_title}
                    >
                      <div className="d-flex align-items-center step-outer ms-2">
                        <div className="step-n-box">
                          <div className="step-number text-center">
                            {index + 1}
                          </div>
                        </div>
                        <div className="step-title mx-3">{box.step_title}</div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div
                      className="d-flex flex-column align-items-center mt-4"
                      key={box.step_title}
                    >
                      <div className="mb-3 content-border">
                        <GatsbyImage
                          image={box.step_content_image.gatsbyImageData}
                          alt={box.step_content_image.alt || "steps image"}
                        />
                      </div>
                      <PrismicRichText field={box.step_content.richText} />
                    </div>
                  </Col>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Row>
      </Container>
    </Container>
  );
};

export default Steps;
